import { catchError } from './Error.action';
import {
  addProduct,
  clearProductList,
  getProductList,
  removeProduct,
} from '../Services/CompareProduct.service';

export const COMPARE_PRODUCT_RECEIVE = 'COMPARE_PRODUCT_RECEIVE';
export const COMPARE_PRODUCT_ERROR = 'COMPARE_PRODUCT_ERROR';
export const SHOW_COMPARE_BUTTON_ERROR = 'SHOW_COMPARE_BUTTON_ERROR';

export const showCompareButtonErrorAction =
  (showCompareButtonError) => (dispatch) => {
    const promise = new Promise((resolve, reject) => {
      resolve();
    });
    return promise.then(() => dispatch(showButtonError(showCompareButtonError)));
  };

export const query = () => (dispatch) => {
  return getProductList()
    .then((result) => {
      dispatch(receive(result));
    })
    .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const remove = (ProductNumber) => (dispatch) => {
  return removeProduct(ProductNumber)
    .then(() => dispatch(query()))
    .then(() => dispatch(showButtonError(null)))
    .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const removeAll = () => (dispatch) => {
  return clearProductList()
    .then(() => dispatch(query()))
    .then(() => dispatch(showButtonError(null)))
    .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const add = (ProductNumber) => (dispatch) => {
  addProduct(ProductNumber)
    .then(() => dispatch(query()))
    .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

const showButtonError = (showCompareButtonError) => ({
  type: SHOW_COMPARE_BUTTON_ERROR,
  payload: {
    showCompareButtonError,
  },
});

const receive = (list) => ({
  type: COMPARE_PRODUCT_RECEIVE,
  payload: {
    list,
  },
});

export const setError = (error) => {
  return {
    type: COMPARE_PRODUCT_ERROR,
    payload: {
      error,
    },
  };
};
